import {
  UserCheck,
  Wrench,
  ShieldCheck,
  ClipboardCheck,
} from "lucide-react";
import { motion } from "framer-motion";

const ITEMS = [
  {
    title: "Atención Personalizada",
    icon: UserCheck,
  },
  {
    title: "Instalación Profesional",
    icon: Wrench,
  },
  {
    title: "Materiales de Alta Calidad",
    icon: ShieldCheck,
  },
  {
    title: "Cotización Sin Compromiso",
    icon: ClipboardCheck,
  },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="border-y border-black/5 bg-persia-light"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 py-7">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;

            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="flex items-center gap-3"
              >
                <span className="w-9 h-9 rounded-full flex items-center justify-center bg-gold text-persia-black shrink-0">
                  <Icon size={18} strokeWidth={2.5} />
                </span>

                <span className="font-display text-[12px] md:text-[13px] tracking-[0.08em] uppercase text-persia-black font-semibold">
                  {item.title}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
